module.exports = __webpack_public_path__ + "static/media/darkLogo.58887873.svg";